function CourseInfo({ name, brief, maxName, maxBrief }) {
    return (
        <div className="text-secondary-color">
            {name && <h3>{name?.split(" ").splice(0, maxName).join(" ")}</h3>}
            {brief && (
                <p className="py-3 text-text-color-ternary">
                    {brief?.split(" ").splice(0, maxBrief).join(" ")}
                </p>
            )}
        </div>
    );
}

export default CourseInfo;
